import { useEffect, useState } from "react";
import { downloadEnrollmentLetter } from "../actions/studensts";
import Loading from "./Loading";

// Fetches a stored enrollment-letter PDF (auth-protected) as a blob and
// shows it in an iframe modal. Shared by the inline student-detail field
// and the Upload Enrollment Letters history table.
export default function PdfViewerModal({ fileName, onClose }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    if (fileName) {
      downloadEnrollmentLetter(fileName).then((res) => {
        if (res && res.status === 200) {
          objectUrl = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
          setPdfBlobUrl(objectUrl);
        }
      });
    }
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      setPdfBlobUrl(null);
    };
  }, [fileName]);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg w-[90vw] h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="font-bold text-lg">PDF Viewer - {fileName}</h3>
          <button
            className="text-gray-500 hover:text-red-500 text-2xl font-bold"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        {pdfBlobUrl ? (
          <iframe src={pdfBlobUrl} className="flex-1 w-full" title="PDF Viewer" />
        ) : (
          <div className="flex-1 flex items-center justify-center">
            <Loading />
          </div>
        )}
      </div>
    </div>
  );
}
